export default __webpack_public_path__ + "static/page-header-do-1-5092b371669e1dab6e83576306342124effc01dccb1d4890744d4fd34bd8b0f5.png";